// Analyze an already-received remote track only. No capture, recording, provider
// request, audio output connection, or synthetic talking timer.
export function mouthShape(samples) {
  let sum = 0;
  for (const sample of samples) {
    if (!Number.isFinite(sample)) return 'neutral';
    sum += sample * sample;
  }
  const rms = samples.length ? Math.sqrt(sum / samples.length) : 0;
  return rms < 0.012 ? 'neutral' : rms < 0.06 ? 'e' : 'a';
}

export function observeReceivedMouth(track, createAnalyser, onShape, onUnavailable = () => {}) {
  let closed = false, timer, analysis, shape = 'neutral';
  const emit = next => { if (!closed && shape !== next) { shape = next; onShape(next); } };
  const close = () => {
    if (closed) return;
    clearInterval(timer);
    emit('neutral'); closed = true;
    if (analysis) Promise.resolve().then(() => analysis.cleanup()).catch(() => {});
  };
  try {
    analysis = createAnalyser(track, { cloneTrack: false, fftSize: 512, smoothingTimeConstant: 0 });
    const samples = new Float32Array(analysis.analyser.fftSize);
    const tick = () => {
      if (closed) return;
      try {
        const media = track.mediaStreamTrack;
        if (!media || media.readyState === 'ended') { close(); return; }
        if (media.muted || media.enabled === false || analysis.analyser.context.state !== 'running') {
          emit('neutral'); return;
        }
        analysis.analyser.getFloatTimeDomainData(samples);
        emit(mouthShape(samples));
      } catch (_) { onUnavailable(); close(); }
    };
    tick();
    if (!closed) timer = setInterval(tick, 50);
  } catch (_) { onUnavailable(); close(); }
  return close;
}
